import React from "react";
import { Card } from "primereact/card";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Tag } from "primereact/tag";
import type { OverdueInvoice } from "../../../types/kpiDashboard";

interface Props {
  invoices: OverdueInvoice[];
}

const daysSeverity = (days: number) => {
  if (days > 60)  return "danger";
  if (days > 14)  return "warning";
  return "success";
};

const OverdueInvoicesTable: React.FC<Props> = ({ invoices }) => {
  const amountBody = (row: OverdueInvoice) =>
    `€${row.amount.toLocaleString("de-DE", { minimumFractionDigits: 2 })}`;

  const daysBody = (row: OverdueInvoice) => (
    <Tag severity={daysSeverity(row.daysOverdue)} value={`${row.daysOverdue} days`} />
  );

  return (
    <Card title="Overdue Invoice Detail">
      <DataTable
        value={invoices}
        size="small"
        sortField="daysOverdue"
        sortOrder={-1}
        emptyMessage="No overdue invoices."
        rowHover
      >
        <Column field="company"    header="Company"    sortable style={{ minWidth: "220px" }} />
        <Column field="amount"     header="Amount"     body={amountBody} sortable style={{ minWidth: "130px" }} />
        <Column field="daysOverdue" header="Days Overdue" body={daysBody} sortable style={{ minWidth: "140px" }} />
        <Column field="docNumber"  header="Invoice No"  style={{ minWidth: "160px", color: "#6c757d" }} />
      </DataTable>
    </Card>
  );
};

export default OverdueInvoicesTable;
